import { FC, useEffect, useState } from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom'

import { BlackOrbKing, WhiteOrbKing } from 'assets/game/orbs'
import landingBg from 'assets/images/game-bg-rocks.png'

import { subscribeToMyGames } from 'features/firebase/game-operations'
import { useAuthStore } from 'features/user/auth-store'
import { PlayerMenu } from 'features/user/player-menu'

import { NavigationMenu, NavigationMenuList, navigationMenuTriggerStyle } from 'shared/components/ui/navigation-menu'

export const LandingPage: FC = () => {
  const navigate = useNavigate()
  const { user } = useAuthStore()
  const [myGames, setMyGames] = useState<string[]>([])

  useEffect(() => {
    if (myGames.length > 0) {
      navigate(`/play/${myGames[0]}`)
    }
  }, [myGames, navigate])

  useEffect(() => {
    if (!user) return

    const unsubscribe = subscribeToMyGames(user.uid, games => {
      if (games) {
        setMyGames(Object.keys(games))
      }
    })

    return unsubscribe
  }, [user])

  return (
    <div className="relative h-screen w-screen">
      <img src={landingBg} alt="Background" className="fixed w-full object-cover" />
      <div className="fixed inset-0 backdrop-blur-sm" />
      <div className="z-10 flex h-full flex-col">
        <div className="z-10 mx-auto mt-4 flex items-center gap-8">
          <WhiteOrbKing size={70} />
          <span className="text-2xl font-bold italic text-white sm:text-6xl">Elementums</span>
          <BlackOrbKing size={70} />
        </div>
        <div className="relative m-5 flex flex-col items-center justify-center gap-4 sm:flex-row md:max-lg:justify-start">
          <NavigationMenu className="w-full">
            <NavigationMenuList className="grid cursor-pointer grid-cols-2 gap-4 *:w-auto md:flex md:flex-row">
              <Link to="/play" className={navigationMenuTriggerStyle()}>
                Play
              </Link>
              <Link to="/how-to" className={navigationMenuTriggerStyle()}>
                How to Play
              </Link>
              <Link to="/buy" className={navigationMenuTriggerStyle()}>
                Buy Board Game
              </Link>
              <Link to="/contact" className={navigationMenuTriggerStyle()}>
                Contact Us
              </Link>
            </NavigationMenuList>
          </NavigationMenu>
          <PlayerMenu />
        </div>
        <div className="z-10">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
